export const BADGE_OUTLINE_ALPHA = '1F'

export type TBadgeColorKey = 'purple' | 'red' | 'green' | 'grey' | 'orange'

interface IBadgeColor {
  color: string
  /** Фон варианта light (макет, компонент custom tag); нет — акцент на 12% */
  light?: string
}

export const BADGE_COLOR: Record<TBadgeColorKey, IBadgeColor> = {
  purple: {
    color: '#8124FF',
    light: '#F9F5FF',
  },
  red: {
    color: '#FF2450',
  },
  green: {
    color: '#00BD7B',
  },
  grey: {
    color: '#8E7CA7',
    light: '#8D7CA71F',
  },
  orange: {
    color: '#F48C06',
  },
}

export const BADGE_COLOR_KEY = Object.keys(BADGE_COLOR) as TBadgeColorKey[]
